module.exports = __webpack_public_path__ + "media/images/new/icons/arrow-0d2d400f0149751586ced54824cdaf36.png";